(function(Drupal, $) {
  Drupal.behaviors.folwellModal = {
    attach: function(context) {
      $('.ui-widget-overlay').css('z-index', 0)
    }
  };
})(Drupal, jQuery);
